export default {
    "Bem vindo(a) ao": "Welkom bij",
    "Entre com suas credenciais": "Voer uw inloggegevens in",
    "do Ginfo abaixo": "van Ginfo hieronder",
    "Empresa": "Bedrijf",
    "empresa_login": "Bedrijf",
    "Selecione a empresa": "Selecteer het bedrijf",
    "E-mail": "E-mail",
    "Senha": "Wachtwoord",
    "Lembrar de mim": "Onthoud mij",
    "Entrar": "Inloggen",
    "Solicite seu acesso": "Vraag uw toegang aan",

    "Portugues": "Portugees",
    "Mercosul": "Mercosur",
    "Ingles": "Engels",
    "Frances": "Frans",
    "Alemao": "Duits",
    "Holandes": "Nederlands",
    "Carregando": "Bezig met laden",
    'TODOS': 'ALLE',
    'BELGIUM': 'BELGIË',
    'GERMANY': 'DUITSLAND',
    'SELECIONE_O_PAIS': 'Selecteer het land',
    'PAIS': 'Land',
    "inicio": "Home",
    "bem_vindo": "Welkom bij",
    "ginfo_analytics": "GINFO Analytics",
    "informacoes_inteligentes": "Slimme inzichten voor snellere, veiligere en strategischere beslissingen",
    "acessados_recentemente": "Recent geopend",
    "buscar_relatorio": "Rapport zoeken",
    "nenhum_relatorio_encontrado": "Geen rapporten gevonden.",
    "acesso_power_bi": "Power BI-toegang",
    "ajuda": "Help",
    "sair": "Uitloggen",
    "agora": "nu",
    "ha": "",
    "minutos": "min geleden",
    "horas": "uur geleden",
    "ontem": "gisteren",
    "dias": "dagen geleden",
    "semanas": "weken geleden",
    "buscar_abrir_relatorio": "Rapport zoeken en openen",
    "mostrar_senha": "Wachtwoord tonen",
    "ocultar_senha": "Wachtwoord verbergen",
    "esqueceu_senha": "Wachtwoord vergeten?",
    "login_frase_inicio": "Betere beslissingen beginnen met",
    "login_frase_destaque": "de juiste informatie",
    "login_frase_2": "het juiste moment",
    "login_frase_3": "de juiste plek",
    "recarregar_relatorio": "Rapport vernieuwen",
    "fechar_aba": "Tab sluiten",
    "horarios_atualizacao": "Horários de atualização",
    "tutorial_desta_tela": "Tutorial voor dit scherm",
    "fechar": "Sluiten",
    "carregando_tutorial": "Tutorial laden...",
    "tutorial_indisponivel": "Tutorial momenteel niet beschikbaar voor dit scherm.",
    "passo": "Stap"
}
